<template>
  <v-select
    class="ma-0"
    item-text="name"
    item-value="value"
    v-model="params.orderBy"
    :items="orderBy"
    @change="applyFilters"
    hide-details
    dense
  />
</template>

<script>
import { mapMutations } from 'vuex'
import store from '@/store'

export default {
  name: 'PaginationOrder',

  props: {
    fetch: {
      type: Function,
      required: true,
    },
    fetchParams: {
      type: Array, 
      required: false
    },
  },

  data() {
    return {
      orderBy: [
        { value: 'ASC', name: this.$t('appointment.filters.sortBy.ASC') },
        { value: 'DESC', name: this.$t('appointment.filters.sortBy.DESC') },
      ],

      params: {
        orderBy: 'DESC',
      },
    }
  },

  methods: {
    ...mapMutations(['setFilters']),

    applyFilters() {
      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...this.params })
      )
        .then(() => this.callFetchFunction())
        .then(() => window.scrollTo({ top: 0, behavior: 'smooth' }))
    },

    callFetchFunction() {
      if (this.fetchParams) {
        this.fetch(...this.fetchParams)
      } else {
        this.fetch()
      }
    },
  },
}
</script>
